import { PermissionType } from 'api/types/entity';
import { ContentHeader } from 'components';
import { useTranslation } from 'libs/i18n';
import { PermissionWrapper } from 'libs/permissions';
import { Button, Stack } from 'libs/ui';
import { useDialog } from 'libs/ui/Dialog/useDialog';
import { Icon } from 'libs/ui/Icon';

import { DialogCreateOrder } from './DialogCreateOrder';
import { SearchBarStyled } from './styles';

interface OrdersHeaderProps {
  search?: string;
  setSearch: (search?: string) => void;
}

export const OrdersHeader = ({ search, setSearch }: OrdersHeaderProps) => {
  const { t } = useTranslation();
  const { isOpen, onClose, open } = useDialog();

  return (
    <ContentHeader
      header={t('order.orders.title')}
      rightContent={
        <Stack direction="row" flexWrap="wrap" spacing={12}>
          <SearchBarStyled
            search={search ?? ''}
            onSearch={(value) => setSearch(value)}
          />
          <PermissionWrapper permissions={[PermissionType.Order_CreateOne]}>
            <Button
              label={t('common.add')}
              sizeVariant="s"
              startIcon={<Icon.Plus />}
              onClick={open}
            />
            <DialogCreateOrder isOpen={isOpen} onClose={onClose} />
          </PermissionWrapper>
        </Stack>
      }
    />
  );
};
